import { Injectable } from '@angular/core';
import { BaseService, ConfigService, LoggingService } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { IDtoAppVersion, IDtoArchive, IDtoDepot, IDtoDevice, IDtoLocation, IDtoResource, IDtoResourceCheck, IDtoResourceType, IDtoResourceFault, IDtoSetting, IDtoShipment, IDtoShipmentProcess, IDtoShipmentReturnCode, IDtoUser, IDtoUserRole } from '@pit/frontend-model';
import { AuthenticationDataService } from '../../services/implementations/authentication.data.service';
import { DtoAppVersionEntityDataService } from '../../services/implementations/dto.app.version.entity.data.service';
import { DtoDepotEntityDataService } from '../../services/implementations/dto.depot.entity.data.service';
import { DtoDeviceEntityDataService } from '../../services/implementations/dto.device.entity.data.service';
import { DtoSettingEntityDataService } from '../../services/implementations/dto.setting.entity.data.service';
import { DtoShipmentEntityDataService } from '../../services/implementations/dto.shipment.entity.data.service';
import { DtoUserEntityDataService } from '../../services/implementations/dto.user.entity.data.service';
import { DtoUserRoleEntityDataService } from '../../services/implementations/dto.user.role.entity.data.service';
import { CommunicationDataService } from '../../services/implementations/communication.data.service';
import { IAuthenticationDataService } from '../../services/interfaces/authentication.data.service.interface';
import { IDtoAppVersionEntityDataService } from '../../services/interfaces/dto.app.version.entity.data.service.interface';
import { IDtoDepotEntityDataService } from '../../services/interfaces/dto.depot.entity.data.service.interface';
import { IDtoDeviceEntityDataService } from '../../services/interfaces/dto.device.entity.data.service.interface';
import { IDtoSettingEntityDataService } from '../../services/interfaces/dto.setting.entty.data.service.interface';
import { IDtoShipmentEntityDataService } from '../../services/interfaces/dto.shipment.entity.data.service.interface';
import { IDtoUserEntityDataService } from '../../services/interfaces/dto.user.entity.data.service.interface';
import { IDtoUserRoleEntityDataService } from '../../services/interfaces/dto.user.role.entity.data.service.interface';
import { ICommunicationDataService } from '../../services/interfaces/communication.data.service.interface';
import { IPinItTrackFrontentDataServicesAccessor } from '../interfaces/pin.it.track.frontent.data.services.accessor.interface';
import { ICronDataService } from '../../services/interfaces/cron.data.service.interface';
import { CronDataService } from '../../services/implementations/cron.data.service';
import { IDtoArchiveEntityDataService } from '../../services/interfaces/dto.archive.entity.data.service.interface';
import { DtoArchiveEntityDataService } from '../../services/implementations/dto.archive.entity.data.service';
import { IDtoShipmentProcessEntityDataService } from '../../services/interfaces/dto.shipment.process.entity.data.service.interface';
import { DtoShipmentProcessEntityDataService } from '../../services/implementations/dto.shipment.process.entity.data.service';
import { IDtoShipmentReturnCodeEntityDataService } from '../../services/interfaces/dto.shipment.return.code.entity.data.service.interface';
import { DtoShipmentReturnCodeEntityDataService } from '../../services/implementations/dto.shipment.return.code.entity.data.service';
import { IDtoLocationEntityDataService } from '../../services/interfaces/dto.location.entity.data.service.interface';
import { DtoLocationEntityDataService } from '../../services/implementations/dto.location.entity.data.service';
import { IDtoResourceEntityDataService } from '../../services/interfaces/dto.resource.entity.data.service.interface';
import { DtoResourceEntityDataService } from '../../services/implementations/dto.resource.entity.data.service';
import { IDtoResourceCheckEntityDataService } from '../../services/interfaces/dto.resource.check.entity.data.service.interface';
import { DtoResourceCheckEntityDataService } from '../../services/implementations/dto.resource.check.entity.data.service';
import { IDtoResourceUserEntityDataService } from '../../services/interfaces/dto.resource.user.entity.data.service.interface';
import { DtoResourceUserEntityDataService } from '../../services/implementations/dto.resource.user.entity.data.service';
import { IDtoResourceTypeEntityDataService } from '../../services/interfaces/dto.resource.type.entity.data.service.interface';
import { DtoResourceTypeEntityDataService } from '../../services/implementations/dto.resource.type.entity.data.service';
import { IDtoResourceFaultEntityDataService } from '../../services/interfaces/dto.resource.fault.entity.data.service.interface';
import { DtoResourceFaultEntityDataService } from '../../services/implementations/dto.resource.fault.entity.data.service';

@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendDataServicesAccessor extends BaseService implements IPinItTrackFrontentDataServicesAccessor {

    constructor(configService: ConfigService, loggingService: LoggingService,
        appVersionDataService: DtoAppVersionEntityDataService, archiveDataService: DtoArchiveEntityDataService, authenticationDataService: AuthenticationDataService,
        depotDataService: DtoDepotEntityDataService, deviceDataService: DtoDeviceEntityDataService,
        communicationDataService: CommunicationDataService, cronDataService: CronDataService, locationDataService: DtoLocationEntityDataService, settingDataService: DtoSettingEntityDataService,
        shipmentDataService: DtoShipmentEntityDataService, shipmentProcessDataService: DtoShipmentProcessEntityDataService, shipmentReturnCodeDataService: DtoShipmentReturnCodeEntityDataService,
        userDataService: DtoUserEntityDataService, userRoleDataService: DtoUserRoleEntityDataService,
        resourceDataService: DtoResourceEntityDataService, resourceCheckDataService: DtoResourceCheckEntityDataService, resourceUserDataService: DtoResourceUserEntityDataService,
        resourceTypeDataService: DtoResourceTypeEntityDataService, resourceFaultDataService: DtoResourceFaultEntityDataService,
        entityDataServiceAccessor: EntityDataServiceAccessorService
    ) {
        super(configService, loggingService, false);

        this.appVersionDataService = appVersionDataService;
        this.archiveDataService = archiveDataService;
        this.authenticationDataService = authenticationDataService;
        this.communicationDataService = communicationDataService;
        this.cronDataService = cronDataService;
        this.depotDataService = depotDataService;
        this.deviceDataService = deviceDataService;
        this.locationDataService = locationDataService;
        this.settingDataService = settingDataService;
        this.shipmentDataService = shipmentDataService;
        this.shipmentProcessDataService = shipmentProcessDataService;
        this.shipmentReturnCodeDataService = shipmentReturnCodeDataService;
        this.userDataService = userDataService;
        this.userRoleDataService = userRoleDataService;
        this.resourceDataService = resourceDataService;
        this.resourceCheckService = resourceCheckDataService;
        this.resourceUserDataService = resourceUserDataService;
        this.resourceTypeDataService = resourceTypeDataService;
        this.resourceFaultDataService = resourceFaultDataService;

        entityDataServiceAccessor.registerEntityDataService<IDtoAppVersion>('dto.app.version', appVersionDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoArchive>('dto.archive', archiveDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoDepot>('dto.depot', depotDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoDevice>('dto.device', deviceDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoLocation>('dto.location', locationDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoSetting>('dto.setting', settingDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoShipment>('dto.shipment', shipmentDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoShipmentProcess>('dto.shipment.process', shipmentProcessDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoShipmentReturnCode>('dto.shipment.return.code', shipmentReturnCodeDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoUser>('dto.user', userDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoUserRole>('dto.user.role', userRoleDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoResource>('dto.resource', resourceDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoResourceCheck>('dto.resource.check', resourceCheckDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoResourceType>('dto.resource.type', resourceTypeDataService);
        entityDataServiceAccessor.registerEntityDataService<IDtoResourceFault>('dto.resource.fault', resourceFaultDataService);

        this.loggingService.debug('PinItTrackFrontendDataServicesAccessor --> constructor()');
    }

    public currentUser: IDtoUser = null;

    public readonly appVersionDataService: IDtoAppVersionEntityDataService = null;

    public readonly archiveDataService: IDtoArchiveEntityDataService = null;

    public readonly authenticationDataService: IAuthenticationDataService = null;

    public readonly communicationDataService: ICommunicationDataService = null;

    public readonly cronDataService: ICronDataService = null;

    public readonly depotDataService: IDtoDepotEntityDataService = null;

    public readonly deviceDataService: IDtoDeviceEntityDataService = null;

    public readonly locationDataService: IDtoLocationEntityDataService = null;

    public readonly settingDataService: IDtoSettingEntityDataService = null;

    public readonly shipmentDataService: IDtoShipmentEntityDataService = null;

    public readonly shipmentProcessDataService: IDtoShipmentProcessEntityDataService = null;

    public readonly shipmentReturnCodeDataService: IDtoShipmentReturnCodeEntityDataService = null;

    public readonly userDataService: IDtoUserEntityDataService = null;

    public readonly userRoleDataService: IDtoUserRoleEntityDataService = null;

    public readonly resourceDataService: IDtoResourceEntityDataService = null;

    public readonly resourceCheckService: IDtoResourceCheckEntityDataService = null;

    public readonly resourceUserDataService: IDtoResourceUserEntityDataService = null;

    public readonly resourceTypeDataService: IDtoResourceTypeEntityDataService = null;

    public readonly resourceFaultDataService: IDtoResourceFaultEntityDataService = null;

    protected override async doInitializeAsync(): Promise<void> {
        await super.doInitializeAsync();

        if (this.isInitialized === false) {
        }
    }

}
